<template>
  <a-layout-footer>
    <div v-if="showInfo" class="infos">
      <div class="infos-container">
        <div class="links">
          <a
            v-if="isThirdPart"
            class="link-item"
            href="https://www.xiong99.com.cn/"
          >
            <img :src="logo" />
            {{ brand }}
          </a>
          <a class="link-item" href="https://matpool.com/">
            矩池云官网
          </a>
          <router-link class="link-item" to="/appendix/manual">
            使用手册
          </router-link>
          <router-link class="link-item" to="/appendix/copyright">
            版权声明
          </router-link>
          <a-popover placement="topLeft" overlayClassName="footer-contact">
            <template slot="content">
              邮箱地址：
              <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
              <copy
                theme="outline"
                size="16"
                fill="rgba(0,0,0,0.15)"
                @click.native="copy(contactEmail, $event)"
              />
            </template>
            <span class="link-item">
              联系我们
            </span>
          </a-popover>
        </div>
        <div class="logo">
          <img src="@/assets/images/matpool_logo.svg" />
          <div class="matpool-desc">由矩池云提供技术支持</div>
        </div>
      </div>
    </div>

    <div class="copyright">
      <span>Copyright © 2019-{{ currentYear }} MATPool.com</span> |
      <span>
        <a href="http://beian.miit.gov.cn/">浙ICP备14013035号-12</a>
      </span>
      |
      <span>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602010194"
        >
          浙公网安备33010602010194号
        </a>
      </span>
    </div>
  </a-layout-footer>
</template>

<script>
import moment from 'moment'
import { Copy } from '@icon-park/vue'
import { copy } from '@/utils/common'
import { isThirdPart } from '@/const'

export default {
  components: {
    Copy
  },
  props: {
    showInfo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isThirdPart,
      contactEmail: 'clubear@clubear.org',
      currentYear: moment().year()
    }
  },
  computed: {
    logo() {
      return require(process.env.VUE_APP_LOGO)
    },
    brand() {
      return process.env.VUE_APP_BRAND
    }
  },
  methods: {
    copy
  }
}
</script>

<style lang="less" scoped>
.infos-container {
  width: @safe-width;
  margin: auto;
  .flex(space-between);
}

.footer-image {
  width: 100%;
  height: 108px;
  background: url('~@/assets/images/footer.svg') no-repeat;
  background-position: center center;
  background-size: cover;
  margin-top: @spacing-6x;
}

.infos {
  border-bottom: 1px solid @grey-200;
  .flex(space-between);

  .links {
    .flex;
    height: 84px;

    .link-item {
      color: fade(@dark, 85%);
      .flex;

      &:not(:last-child) {
        margin-right: @spacing-12x;
      }

      img {
        width: 26px;
        height: 26px;
        border-radius: 50%;
      }
    }
  }
}

.matpool-desc {
  color: fade(@dark, 35%);
  font-size: @font-sm;
  line-height: 16px;
  margin-top: @spacing-3x;
}

.copyright {
  text-align: center;
  height: 36px;
  line-height: 36px;
  color: fade(@dark, 35%);

  a {
    color: fade(@dark, 35%);

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

<style lang="less">
.footer-contact {
  .text-normal;

  .ant-popover-inner-content {
    padding: @spacing-4x;
  }
  a:hover {
    text-decoration: underline;
  }
  .i-icon {
    vertical-align: text-bottom;
    margin-left: @spacing-2x;
    cursor: pointer;
  }
}
</style>
